// a fake global state manager with 'vue reactive'; see https://pinia.vuejs.org/ for a more pro approach

import { reactive } from 'vue'


export const stateManager = reactive({
    total_favorite_count: 0,
    animate() {
        this.animationEnabled = !this.animationEnabled;
    },
    animationEnabled: false,
    isSearchInputActive: false,

    /** favorite verses {} is something like
     * {
            1: [ "Beato l’uomo che non segue il consiglio degli empi,...", ],
            7: [ ... ]
        }
        Is updated one at app start up, and updated *lazily* when a user add/delete from favorites
     */
    favoriteVerses: {}
});